import React from "react";
import { Modal, Form, Input, Select, Switch, Space, Button } from "antd";

const { Option } = Select;

const ModalCampo = ({
  isVisible,
  isNewField,
  onCancel,
  onSave,
  form,
  selectedTipo,
  setSelectedTipo,
  existingFields = [],
  editingField = null,
}) => {
  return (
    <Modal
      title={isNewField ? "Agregar Nuevo Campo" : "Editar Campo"}
      open={isVisible}
      onCancel={onCancel}
      footer={null}
      width={600}
    >
      <Form form={form} onFinish={onSave} layout="vertical">
        <Form.Item
          name="label"
          label="Etiqueta"
          rules={[
            { required: true, message: "Por favor ingrese la etiqueta" },
            {
              validator: (_, value) => {
                if (!value) return Promise.resolve();
                
                // Convertir a minúsculas para comparación
                const normalizedValue = value.toLowerCase().trim();
                
                // Verificar si ya existe un campo con el mismo label (ignorando mayúsculas/minúsculas)
                const existingField = existingFields.find(field => {
                  // Si estamos editando, excluir el campo actual
                  if (!isNewField && editingField && field.id === editingField.id) {
                    return false;
                  }
                  return field.label.toLowerCase().trim() === normalizedValue;
                });
                
                if (existingField) {
                  return Promise.reject(new Error(`Ya existe un campo con la etiqueta "${existingField.label}"`));
                }
                
                return Promise.resolve();
              }
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="tipo"
          label="Tipo"
          rules={[{ required: true, message: "Por favor seleccione el tipo" }]}
        >
          <Select onChange={(value) => setSelectedTipo(value)}>
            <Option value="texto">Texto</Option>
            <Option value="numero">Número</Option>
            <Option value="select">Select</Option>
            <Option value="multiple_unico">Selección Única</Option>
            <Option value="multiple_multiple">Selección Múltiple</Option>
            <Option value="fecha">Fecha</Option>
            <Option value="imagen">Imagen</Option>
          </Select>
        </Form.Item>
        {["select", "multiple_unico", "multiple_multiple"].includes(
          selectedTipo
        ) && (
          <Form.Item
            name="opciones"
            label="Opciones (separadas por comas)"
            rules={[{ required: true, message: "Por favor ingrese las opciones" }]}
          >
            <Input placeholder="Ejemplo: opción 1, opción 2, opción 3" />
          </Form.Item>
        )}
        {selectedTipo === "imagen" && (
          <Space direction="vertical" style={{ width: "100%" }}>
            <Form.Item name="camara" valuePropName="checked">
              <Switch checkedChildren="Cámara" unCheckedChildren="Sin Cámara" />
            </Form.Item>
            <Form.Item name="galeria" valuePropName="checked">
              <Switch checkedChildren="Galería" unCheckedChildren="Sin Galería" />
            </Form.Item>
          </Space>
        )}
        <Form.Item name="requerido" valuePropName="checked">
          <Switch checkedChildren="Requerido" unCheckedChildren="Opcional" />
        </Form.Item>
        <Form.Item name="visible_app" valuePropName="checked">
          <Switch
            checkedChildren="Visible en App"
            unCheckedChildren="Oculto en App"
          />
        </Form.Item>
        <Form.Item>
          <Space>
            <Button type="primary" onClick={() => form.submit()}>
              {isNewField ? "Crear" : "Guardar"}
            </Button>
            <Button onClick={onCancel}>Cancelar</Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalCampo; 